import type { Collection } from "@/types";
import type { InventoryCollection } from "./types";

export function transformCollection(
  collection: Collection,
  walletAddress?: string,
): InventoryCollection {
  return {
    name: collection.name,
    image: collection.image,
    address: collection.address,
    network: collection.network,
    symbol: collection.symbol,
    walletAddress,
  };
}

export function sortCollections(
  collections: InventoryCollection[],
  sortBy: "name" = "name",
): InventoryCollection[] {
  return [...collections].sort((a, b) => {
    if (sortBy === "name") {
      return a.name.localeCompare(b.name);
    }
    return 0; // Default case - no sorting
  });
}
